import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../services/api";

export default function ProcessoClienteDetalhe() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/cliente_processo_detalhe.php?id=${id}`)
      .then(res => setData(res.data))
      .catch(err => console.error("Erro detalhe processo:", err))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div className="p-6 text-slate-400">
        Carregando informações do processo...
      </div>
    );
  }

  if (!data?.processo) {
    return (
      <div className="p-6 text-red-400">
        Processo não encontrado.
      </div>
    );
  }

  const { processo, resumo, movimentacoes, prazos } = data;

  return (
    <div className="p-6 space-y-8">
      {/* CABEÇALHO */}
      <div>
        <h1 className="text-xl font-semibold text-slate-100">
          Processo nº {processo.numero}
        </h1>
        <p className="text-sm text-slate-400">
          {processo.vara} • {processo.comarca}
        </p>
      </div>

      {/* STATUS */}
      <span className="
        inline-block rounded-full px-3 py-1 text-xs font-medium
        bg-blue-500/10 text-blue-400
      ">
        {processo.status}
      </span>

      {/* 🧠 RESUMO HUMANO */}
      <div className="rounded-xl border border-[#1f2937] bg-[#121826] p-4">
        <p className="text-sm text-slate-300">
          {resumo}
        </p>
      </div>

      {/* ⏰ PRAZOS */}
      <div>
        <h2 className="text-lg font-semibold text-slate-100 mb-3">
          Próximos prazos
        </h2>

        {prazos.length === 0 && (
          <p className="text-sm text-slate-400">
            Não há prazos cadastrados no momento.
          </p>
        )}

        <ul className="space-y-3">
          {prazos.map((p, i) => (
            <li
              key={i}
              className="rounded-xl border border-[#1f2937] bg-[#121826] p-4"
            >
              <p className="text-sm text-slate-100">
                {p.descricao}
              </p>
              <p className="text-xs text-slate-400">
                Data: {new Date(p.data_prazo).toLocaleDateString()}
              </p>
            </li>
          ))}
        </ul>
      </div>

      {/* 🕒 MOVIMENTAÇÕES */}
      <div>
        <h2 className="text-lg font-semibold text-slate-100 mb-3">
          Histórico de movimentações
        </h2>

        {movimentacoes.length === 0 && (
          <p className="text-sm text-slate-400">
            Nenhuma movimentação registrada.
          </p>
        )}

        <ul className="space-y-3">
  {movimentacoes.map((m, i) => (
    <li
      key={i}
      className="rounded-xl border border-[#1f2937] bg-[#121826] p-4"
    >

      {/* RESUMO HUMANO (PRIORIDADE) */}
      {m.resumo && (
        <p className="text-sm text-slate-200 leading-relaxed">
          {m.resumo}
        </p>
      )}

      {/* DESCRIÇÃO TÉCNICA (SECUNDÁRIA) */}
      <p className="mt-2 text-xs text-slate-400">
        {m.descricao}
      </p>

      {/* DATA */}
      <p className="mt-1 text-[11px] text-slate-500">
        {new Date(m.criado_em).toLocaleDateString()}
      </p>

    </li>
  ))}
</ul>

      </div>
    </div>
  );
}
